"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/modules/es6.object.assign");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const atoms_1 = require("@components/atoms");
const _theme_1 = require("@theme");
const _utils_1 = require("@utils"); // Component
var HomepageHeroPanel = function HomepageHeroPanel(_ref) {
    var headline = _ref.headline, body = _ref.body, to = _ref.to, onClick = _ref.onClick, cta = _ref.cta;
    return /*#__PURE__*/ react_1.default.createElement(Wrapper, null, /*#__PURE__*/ react_1.default.createElement(Content, null, /*#__PURE__*/ react_1.default.createElement(Copy, null, /*#__PURE__*/ react_1.default.createElement(Headline, {
        dangerouslySetInnerHTML: {
            __html: headline
        }
    }), /*#__PURE__*/ react_1.default.createElement(Body, {
        dangerouslySetInnerHTML: {
            __html: body
        }
    })), /*#__PURE__*/ react_1.default.createElement(ButtonWrapper, null, /*#__PURE__*/ react_1.default.createElement(StyledButton, Object.assign({
        to: to,
        onClick: onClick
    }, {
        shadow: true
    }), cta)), /*#__PURE__*/ react_1.default.createElement(BoxShadow, null)));
}; // Styling
var Wrapper = styled_components_1.default.div.withConfig({
    displayName: "HomepageHeroPanel__Wrapper",
    componentId: "sc-14v0opq-0"
})(["position:relative;display:flex;justify-content:center;align-items:center;padding:64px 16px;", "{padding:80px 8px;}", "{padding:96px 24px;}", "{padding:128px 48px;}"], _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var Content = styled_components_1.default.div.withConfig({
    displayName: "HomepageHeroPanel__Content",
    componentId: "sc-14v0opq-1"
})(["position:relative;display:flex;flex-direction:column;justify-content:space-between;align-items:center;background-color:", ";width:256px;height:100%;min-height:268px;padding:32px 24px;", "{width:240px;min-height:284px;padding:40px 12px;}", "{width:290px;min-height:302px;}", "{width:330px;min-height:355px;padding:48px 32px;}"], _theme_1.palette.snow, _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var BoxShadow = styled_components_1.default.div.withConfig({
    displayName: "HomepageHeroPanel__BoxShadow",
    componentId: "sc-14v0opq-2"
})(["z-index:-1;position:absolute;bottom:2%;left:3%;width:94%;height:94%;box-shadow:0 16px 24px ", ";"], _utils_1.rgba(_theme_1.palette.black, 0.16));
var Copy = styled_components_1.default.div.withConfig({
    displayName: "HomepageHeroPanel__Copy",
    componentId: "sc-14v0opq-3"
})(["position:relative;"]);
var Headline = styled_components_1.default.div.withConfig({
    displayName: "HomepageHeroPanel__Headline",
    componentId: "sc-14v0opq-4"
})(["", " text-align:center;"], _theme_1.type.h3Uppercase);
var Body = styled_components_1.default.div.withConfig({
    displayName: "HomepageHeroPanel__Body",
    componentId: "sc-14v0opq-5"
})(["", " text-align:center;padding-top:10px;", "{padding-top:24px;}"], _theme_1.type.pSmall, _utils_1.mediaQuery('desktop'));
var ButtonWrapper = styled_components_1.default.div.withConfig({
    displayName: "HomepageHeroPanel__ButtonWrapper",
    componentId: "sc-14v0opq-6"
})(["width:fit-content;padding-top:24px;", "{padding-top:30px;}", "{padding-top:38px;}"], _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var StyledButton = styled_components_1.default(function (props) {
    return /*#__PURE__*/ react_1.default.createElement(atoms_1.Button, props);
}).withConfig({
    displayName: "HomepageHeroPanel__StyledButton",
    componentId: "sc-14v0opq-7"
})(["", "{", ":hover &{filter:contrast(120%);transform:translate3d(0,-2px,0) scale3d(1.015,1.01,1);}}"], _utils_1.mediaQuery('tablet'), Wrapper); // Types
exports.default = HomepageHeroPanel;
